import React, { useMemo } from 'react';
import { SearchSelect } from '@app/ui';
import NestedSelect from '../../components/common/NestedSelect';
import PropTypes from 'prop-types';
import {
    getSelectedValues,
    toSearchSelectOptions,
    toSelectedObject,
} from '@app/utils/multiSelectValue';

const MultiSelectFilter = ({ column, filter }) => {
    const { options, onChange, selected, isNested } = useMemo(
        () => filter[column],
        [filter, column],
    );

    return (
        <>
            {isNested && (
                <NestedSelect
                    placeholder=""
                    options={options}
                    size="sm"
                    onChange={onChange}
                    selected={selected}
                    autoClearSearchValue={false}
                />
            )}
            {!isNested && (
                <SearchSelect
                    mode="multiple"
                    placeholder=""
                    options={toSearchSelectOptions(options)}
                    size="sm"
                    onChange={value => onChange(toSelectedObject(value))}
                    value={getSelectedValues(options, selected)}
                    autoClearSearchValue={false}
                />
            )}
        </>
    );
};

MultiSelectFilter.propTypes = {
    column: PropTypes.string,
    filter: PropTypes.object,
};

export default MultiSelectFilter;
